module.exports = __webpack_public_path__ + "img/tiktok.1bf366b1.svg";